"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateErrorReportBodySchema = void 0;
const core_1 = require("../../../core");
const common_1 = require("../common");
exports.CreateErrorReportBodySchema = (0, core_1.StrictObject)(common_1.ErrorFields);
